import { useSelector } from 'react-redux'

import { nlpSelector } from '../selectors/selectors'

export function useNlp() {
  return useSelector(nlpSelector)
}
